import React, { useEffect } from 'react';
import { Container, Typography } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { browserHistory } from 'browser-history';
import { CollectorIntermediatePageSkeleton } from './CollectorIntermediatePageSkeleton';
import { InstallBanner } from './InstallBanner';
import { useCollectorItem } from './hooks';
import useCollectorIntermediateStyles from './hooks/useCollectorIntermediateStyles';

export const CollectorUninstallPage: React.FC = () => {
  const classes = useCollectorIntermediateStyles();
  const { collectorItem, loading, refreshURL } = useCollectorItem();
  useEffect(() => {
    if (loading || !collectorItem) return;
    if (!collectorItem) return;
    if (refreshURL) {
      localStorage.setItem('collectorDesktopRefreshURL', refreshURL);
    }
    setTimeout(() => {
      browserHistory.replace('');
      window.location.assign(collectorItem.uninstallUrl);
    }, 2000);
  }, [loading, collectorItem, refreshURL]);

  if (loading) return <CollectorIntermediatePageSkeleton />;

  return (
    <div className={classes.root} data-testid="collector-uninstall-page">
      <Container className={classes.textContainer}>
        <Typography variant="h2">
          <FormattedMessage id="collectors.uninstallMessage1" />
        </Typography>
      </Container>
      <InstallBanner imageSrc={collectorItem?.imageSrc} classes={classes} />
      <Container className={classes.textContainer}>
        <Typography variant="h4">
          <FormattedMessage
            id="collectors.uninstallMessage2"
            values={{ collector: collectorItem?.name }}
          />
        </Typography>
        <Typography variant="h4" align="center">
          <FormattedMessage id="collectors.uninstallMessage3" />
        </Typography>
      </Container>
    </div>
  );
};

export default React.memo(CollectorUninstallPage);
